import { ComputerOutlined, LocationOnOutlined } from '@mui/icons-material';
import { Box, Divider, Grid, Stack, Typography } from '@mui/material';

import { Tag } from '../../../components/general/Tag';
import { LeistungIndexTags } from '../../../components/general/ThemaHeader/LeistungIndexTags.tsx';
import { ModulFromThemaRouter } from '../../../dtos';
import { formatDuration } from '../../../utils/dateFormat/durationFormat';
import { getLeistungstemplatesFromModul } from '../../../utils/getLeistungstemplatesFromModul.ts';
import { printModulFormat } from '../../../utils/printModulFormat.ts';
import { ModulCardLabelValue } from './ModulCardLabelValue';
import { VNummer } from './VNummer';

type ModulCardProps = {
  readonly modul: ModulFromThemaRouter;
};

export const ModulCard = ({ modul }: ModulCardProps) => {
  const {
    beginn,
    modulFormat,
    isOnline,
    titel,
    dauer,
    ablaufUhrzeitenText,
    trainer,
    gruppenraumInfo,
    kommentar,
    vNummer,
    modulSapId,
    akaModulId,
  } = modul;

  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: (theme) => theme.palette.surface.elevated,
        borderRadius: '4px',
        border: (theme) => `1px solid ${theme.palette.border.subtle}`,
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
        <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
          {
            <Tag style="brand" size="small">
              {isOnline ? (
                <ComputerOutlined sx={{ fontSize: '16px' }} />
              ) : (
                <LocationOnOutlined sx={{ fontSize: '16px' }} />
              )}
              {printModulFormat(modulFormat)}
            </Tag>
          }
          <LeistungIndexTags leistungstemplates={getLeistungstemplatesFromModul(modul)} />
          {<Typography variant="label"> {titel}</Typography>}
        </Stack>
        <Stack direction="row" spacing={2}>
          <VNummer vNummer={vNummer} modulSapId={modulSapId} akaModulId={akaModulId} />
          {beginn && <Tag style="outline" size="small">{`${beginn.text} ${beginn.value} ${beginn.unit}`}</Tag>}
        </Stack>
      </Stack>

      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid size={3}>
          <ModulCardLabelValue label="Dauer" value={dauer && formatDuration(dauer)} />
        </Grid>
        <Grid size={3}>
          <ModulCardLabelValue label="Uhrzeit" value={ablaufUhrzeitenText} />
        </Grid>
        <Grid size={3}>
          <ModulCardLabelValue label="Trainer:in" value={trainer} />
        </Grid>
        <Grid size={3}>
          <ModulCardLabelValue label="Gruppenraum" value={gruppenraumInfo} />
        </Grid>
      </Grid>

      {kommentar && (
        <>
          <Divider sx={{ my: 2 }} />
          <Typography variant="labelLight">{kommentar}</Typography>
        </>
      )}
    </Box>
  );
};
